// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2945":"dd1a35db","6082":"55c7e163"}[chunkId] + ".chunk.css";
};